import { kevinAuthAPI } from 'apis/config';
import ErrorMessage from '../ErrorMessage';
import { ILang, ICoupon } from '../../utils/types/saleTypes';
import { INotice, INoticeDetail } from '../../utils/types/operationTypes';

// export const noticeApis = {
//   getNoticeList: (projectId: number) : Promise<INotice[]> => {
//     return new Promise((resolve) => {
//       // 임시 JSON 데이터 (목 데이터)
//       const mockData: INotice[] = [
//         {
//           notice_id: 1,
//           notice_type: 'General',
//           notice_name: 'Maintenance Notice',
//           project_id: projectId,
//           from_date: '2024-10-01',
//           to_date: '2024-10-02',
//           os: 'Android',
//           sortkey: 1,
//           exception_culture: null,
//         },
//         {
//           notice_id: 2,
//           notice_type: 'Update',
//           notice_name: 'Version Update v1.2.3',
//           project_id: projectId,
//           from_date: '2024-10-05',
//           to_date: '2024-10-10',
//           os: 'iOS',
//           sortkey: 2,
//           exception_culture: 'ko-KR',
//         },
//         {
//           notice_id: 3,
//           notice_type: 'General',
//           notice_name: 'Holiday Event',
//           project_id: projectId,
//           from_date: '2024-12-01',
//           to_date: '2024-12-25',
//           os: 'all',
//           sortkey: 3,
//           exception_culture: null,
//         },
//       ];
//       resolve(mockData);
//     });
//   },
//
//   getNotice: (projectId: number, noticeId: number) => {
//     return new Promise((resolve, reject) => {
//       const mockData: INotice = {
//         notice_id: noticeId,
//         notice_type: 'General',
//         notice_name: `Mock Notice ${noticeId}`,
//         project_id: projectId,
//         from_date: '2024-10-01',
//         to_date: '2024-10-02',
//         os: 'All',
//         sortkey: 1,
//         exception_culture: null,
//       };
//       resolve(mockData);
//     });
//   },
//
//   updateNotice: (notice: INotice) => {
//     return new Promise((resolve) => {
//       resolve({ message: `Notice ${notice.notice_id} updated successfully!` });
//     });
//   },
//
//   createNotice: (projectId: number, notice: INotice) => {
//     return new Promise((resolve) => {
//       resolve({ message: `Notice created for project ${projectId}` });
//     });
//   },
//
//   deleteNotice: (projectId: number, noticeId: number) => {
//     return new Promise((resolve) => {
//       resolve({ message: `Notice ${noticeId} deleted successfully!` });
//     });
//   },
//
//   uploadNoticeBanner: (project_id: number, notice_id: number, file: any) => {
//     return new Promise((resolve) => {
//       resolve({ message: `Banner for notice ${notice_id} uploaded successfully!` });
//     });
//   },
// };
export const noticeApis = {
  getNoticeList: (projectId: number) =>
    kevinAuthAPI.get(`/notice/${projectId}`).then((res) => res.data),
  getNotice: (projectId: number, noticeId: number) => {
    return kevinAuthAPI
      .get(`/notice/${projectId}/${noticeId}`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      });
  },
  updateNotice: (notice: INotice) => {
    return kevinAuthAPI
      .patch(`/notice/${notice.notice_id}`, notice)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      });
  },
  createNotice: (projectId: number, notice: INotice) => {
    return kevinAuthAPI
      .post(`/notice/${projectId}`, notice)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      });
  },
  createNoticeDetail: (
    projectId: number,
    noticeId: number,
    noticeDetail: INoticeDetail,
  ) => {
    return kevinAuthAPI
      .post(`/notice/${projectId}/${noticeId}/lang`, noticeDetail)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      });
  },
  deleteNotice: (projectId: number, noticeId: number) => {
    return kevinAuthAPI
      .delete(`/notice/${projectId}/${noticeId}`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      });
  },
  deleteNoticeDetail: (
    projectId: number,
    noticeId: number,
    noticeDetailId: number,
  ) => {
    return kevinAuthAPI
      .delete(`/notice/${projectId}/${noticeId}/${noticeDetailId}`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      });
  },
  uploadNoticeBanner: (
    projectId: number,
    noticeId: number,
    noticeDetailId: number,
    file: any,
  ) => {
    const formData = new FormData();
    formData.append('file', file);
    return kevinAuthAPI
      .patch(
        `/notice/upload-banner/${projectId}/${noticeId}/${noticeDetailId}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      )
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      });
  },
};
